import { Component } from "react";
import "../css/bootstrap.css";
import $ from "jquery";
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import { CloudSearch } from "aws-sdk";
import { saveItCareerForm } from "../service";

class footerSub2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditorNoteActive: "0",
      NoteSecArray: [],
      NoteSecArrayList: [],
      NoteSecArrayTextstate: ""

    }
  }
  componentDidMount() {
    this.setState({
      NoteSecContentId: this.props.NoteSecArray[0].contentDataId,
      NoteSecArrayList: this.props.NoteSecArray[0].listing,
    });
    if (this.props.NoteSecArray[0].listing.length > 0) {
      this.setState({
        NoteSecArrayTextstate: this.props.NoteSecArray[0].listing[0].contentDataSubSubtitle,
      })
    }
  }
  save() {
    var flag = true
    if ($("#notetextareaTxt").val() === '') {
      alert("Enter Text")
      flag = false
    }
    if (flag == true) {
      let contentDataId = this.state.NoteSecContentId
      let description = $("#notetextareaTxt").val()

      this.savePoweredBy(
        contentDataId,
        description,
      );
    }
  }
  savePoweredBy(
    contentDataId, description
  ) {
    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      // contentDataSubId:"",
      contentDataSubId: this.state.NoteSecArrayList.length > 0 ? this.props.NoteSecArray[0].listing[0].contentDataSubId : "",
      contentDataSubDescription: "",
      contentDataSubTitle: "",
      siteId: "",
      contentDataSubIsApproved: "0",
      image: "",
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
      altText: "",
      h3Tag: "",
      contentDataSubSubtitle: description,
    };
    console.log("postDataaaa", postData);
    saveItCareerForm(postData).then((data) => {
      console.log("hhhhhh.....", data);
      if (data.data.success == 1) {
        this.props.getData();
        this.cancelNoteSec();
      }
    });
  }


  AddNoteSec() {
    $(".Notetext_wrapper").addClass("editActive");
    this.setState({ isEditorNoteActive: "1" });
  }
  cancelNoteSec() {
    $(".Notetext_wrapper").removeClass("editActive");
    this.setState({ isEditorNoteActive: "0" });
  }
  editNoteSec() {
    $(".Notetext_wrapper").addClass("editActive");
    this.setState({ isEditorNoteActive: "1" });
    if (this.state.NoteSecArrayList.length > 0) {
      $("#notetextareaTxt").val(this.props.NoteSecArray[0].listing[0].contentDataSubSubtitle)
    }
  }

  deleteNoteSec(mode) {
    if (mode === "delete") {
      const postData = {
        functionName: "delete",
        contentDataSubId: this.props.NoteSecArray[0].listing[0].contentDataSubId,
      };
      if (window.confirm("Do you want to delete?")) {
        saveItCareerForm(postData).then((data) => {
          if (data.data.success == 1) {
            this.props.getData();
            window.location.reload();
          }
        });
      } else {
        return false;
      }
    }
  }
  render() {
    return (
      <div className="Notetext_wrapper">
        {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
          <>
            <div className="adminIconMain" style={{ top: "54px" }}>
              {console.log("this.props.NoteSecArray[0].listing=", this.props.NoteSecArray[0].listing)}
              {this.props.NoteSecArray[0].listing.length == "0" ?
                <span
                  className="editIcon addButton"
                  onClick={(e) => {
                    this.AddNoteSec();
                  }}
                >
                  <img src={Add} />
                </span>
                :
                <>
                  <span
                    class="editIcon editButton"
                    onClick={(e) => {
                      this.editNoteSec();
                    }}
                  >
                    <img src={Edit} />
                  </span>
                  {/* <span class="editIcon lockButton"><img src={lock} /></span> */}
                  <span class="editIcon DeleteIcon"
                    onClick={() => this.deleteNoteSec("delete")}
                  >
                    <img src={Delete} />
                  </span>
                </>
              }
            </div>
            {/* <div className="adminIconLeft">
          <div className="approveButton">Approve</div>
          <div class="draftSpan"> Draft </div>
          <div className="rejectSection">
            <div class="rejectButton"> Reject </div>
            <textarea
              className="rejectComment"
              placeholder="Enter Reason"
            ></textarea>
          </div>
          <div className="rejectSection">
            <div class="rejectButton"> Rejected </div>
            <div className="rejectCommentText">Reason :</div>
          </div>
        </div> */}
          </>
        }
        <p className="hashtag">
          <strong>
            <sup>#</sup>Note:
          </strong>{" "}
          {this.props.NoteSecArray[0].listing.length > 0 ?
            this.props.NoteSecArray[0].listing[0].contentDataSubSubtitle
            : ""}
        </p>
        {/* <input type="text" placeholder="Enter Title" autocomplete="off" maxlength="80" class="editInput" id="poweredByinputTxt" /> */}
        <textarea class="editInput" id="notetextareaTxt" style={{ minHeight: "70px" }}></textarea>
        <div className="editPanelButton">
          {/* <span className="saveButton saveDraft">Save Draft</span> */}
          <span className="saveButton" onClick={() => { this.save() }}>Submit</span>
          <span className="cancelButton" onClick={(e) => { this.cancelNoteSec() }}>Cancel</span>
        </div>
      </div>

    );
  }
}
export default footerSub2;
